/**
 * @file Video Trigger.
 */

import BiggerPicture from 'bigger-picture'; // eslint-disable-line import/no-unresolved

/**
 * Video Trigger component.
 */
const vVideoTrigger = () => {
	const videoTriggers = document.querySelectorAll('.v-video-trigger');

	if (!videoTriggers || videoTriggers.length === 0) {
		return;
	}

	const lb = BiggerPicture({
		target: document.querySelector('.v-full-page'),
	});

	[...videoTriggers].forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();

			const source = trigger.getAttribute('data-source');
			const id = trigger.getAttribute('data-video-id');
			const src = source === 'youtube' ? `https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1` : `https://player.vimeo.com/video/${id}?h=631eb60515&title=0&byline=0&portrait=0&autoplay=1`;

			lb.open({
				intro: 'fadeup',
				items: [{
					iframe: src,
				}],
			});
		});
	});
};

export default vVideoTrigger;
